import React, { useCallback, useEffect, useRef, useState } from 'react'
import { reformat } from '../../../../hooks/useMyStrings';
import NoteTooltip from '../meta/NoteTooltip';
import useWebSocketCaller from '../../../../hooks/useWebSocketCaller';
import { useItemListenerContext } from '../../../../providers/ItemListenerContextProvider';
import './ValEdit.css'

export default function ValEdit({folderPath, keyName, val, setLabelMode, kInfo, tabIx}) {  
  //console.log('[ValEdit] %s --- %s: %s', folderPath, keyName, val);
  const taggedEditingRef                    = useRef(false);  
  const [content, setContent]               = useState(kInfo.valErrorInfo ? kInfo.valErrorInfo.val : val);
  const {sendMessage}                       = useWebSocketCaller();
  const {resetValueKInfo, tagValueEditing}  = useItemListenerContext();
  
  useEffect(()=>{    
    if (!taggedEditingRef.current) {
      tagValueEditing(folderPath, keyName)
        .then(()=>taggedEditingRef.current=true);
    }
  }, [tagValueEditing, folderPath, keyName]);
  
  // ------[  updateContent  ]------
  //
  const updateContent = useCallback((e) => {
    const update = reformat(e.target.value);
    setContent(update);
  }, []);

  // ------[  Revert  ]------
  //
  const revert = useCallback(() => {
    if (taggedEditingRef.current) {
      taggedEditingRef.current = false;      
      resetValueKInfo(folderPath, keyName)
        .then(()=>setContent(val))
        .then(setLabelMode);
        // Changes on the server might be for "keyEdit" flag, in case we have implemented "shared edit state detection"
        // But, the edit flag should only be local, so it will be cleared only locally by configsData refresh.    
    }    
  }, [resetValueKInfo, folderPath, keyName, setContent, setLabelMode, val]);


  // ---[  Save  ]---
  //
  const save = useCallback(() => {
    if (content !== val) {
      console.log('[ValEdit] Saving... [content: %s] [val: %s]', content, val);
      sendMessage('update-config-val', {
        'basePath': folderPath,
        'key': keyName,
        'val': content
      });
    }
    else {
      console.log('[ValEdit] Reverted');
      revert();
    }
  }, [sendMessage, folderPath, keyName, content, val, revert]);
  
  /** [Enter], [Esc] **/
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      save();
    }
    else if (e.key === 'Escape') {
      revert();
    }
  }, [save, revert]);

  const errSubject = kInfo.valErrorInfo?.message      || '';
  const errBody    = kInfo.valErrorInfo?.suggestion   || '';

  return (
    <div className='valEdit'>
      {errSubject && <NoteTooltip subject={errSubject} body={errBody} />}
      <input className='valInput'
             type='text' value={content}
             autoFocus={true}
             onChange={updateContent} 
             onBlur={save}
             onKeyDown={handleKeyDown}
             tabIndex={tabIx}/>
    </div>
  )
}
